<script>
    export let title;

    $: shouldAnimate =
        (document.getElementById("title")?.scrollWidth ?? 0) >
        window.innerWidth - 32;

    // update animation state when window has rendered
    setTimeout(() => {
        shouldAnimate =
            (document.getElementById("title")?.scrollWidth ?? 0) >
            window.innerWidth - 32;
    }, 200);
</script>

<div id="title" class="title headline-s">
    <span class="title-text" class:animate={shouldAnimate}>{title}</span>
</div>

<style>
    .title {
        margin-left: 16px;
        white-space: nowrap;
        /* overflow: hidden; */
    }

    .title-text {
        display: block;
        text-align: start;
    }

    .animate {
        transform: translateX(0);
        animation: moveSlideshow 16s linear infinite;
    }

    @media (min-width: 480px) {
        .animate {
            animation: moveSlideshow 24s linear infinite;
        }
    }

    @media (min-width: 768px) {
        .animate {
            animation: moveSlideshow 32s linear infinite;
        }

        @keyframes moveSlideshow {
        0% {
            transform: translateX(0);
        }
        40% {
            transform: translateX(0);
        }
        76% {
            transform: translateX(-100%);
        }
        76.001% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(0);
        }
    }
    }

    @keyframes moveSlideshow {
        0% {
            transform: translateX(0);
        }
        40% {
            transform: translateX(0);
        }
        76% {
            transform: translateX(-200%);
        }
        76.001% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(0);
        }
    }
</style>
